/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chatheader1Inputs */

const en_chatheader1 = /** @type {(inputs: Chatheader1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

const pt_chatheader1 = /** @type {(inputs: Chatheader1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

/**
* | output |
* | --- |
* | "Chat" |
*
* @param {Chatheader1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const chatheader1 = /** @type {((inputs?: Chatheader1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatheader1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chatheader1(inputs)
	return pt_chatheader1(inputs)
});
export { chatheader1 as "chatHeader" }